module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-bounce-in-right/wow-bounce-in-right.component.scss
// module id = ./src/app/features/wow-slider/wow-bounce-in-right/wow-bounce-in-right.component.scss
// module chunks = main